import React from 'react'

import { Icons as BriqCommonIcons } from '@briq/shared'

type IconProps = { color?: string; fontSize?: string; size?: { width?: string; height?: string } }

export function asStyledIcon(iconComponent: React.ComponentType<Omit<IconProps, 'size'>>) {
  return BriqCommonIcons.asStyledIcon(iconComponent)
}

export const Icon = BriqCommonIcons.Icon
